import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import TablePage from "@beeldit/core/pages/TablePage";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";

function CashReconciliationsPage(props: {
  filters?: any;
  formDefaultValues?: any;
  formFilterValues?: any;
}) {
  const { filters, formDefaultValues, formFilterValues } = props;

  const tablePageParams = {
    modelConfig: config,
    formDefaultValues: formDefaultValues || null,
    filters: filters || null,
    formFilterValues: formFilterValues || null,
  };

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <TablePage {...tablePageParams} />
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default CashReconciliationsPage;
